module.exports = [function () {
  // H5以URL scheme方式传递消息给Native端，Native通过拦截URL捕获消息
  // Native以执行挂载在window上的方法来传递消息给H5端，H5通过方法内部解析参数的方式获取Native
  // 传递过来的消息，以此实现Native与H5的双向沟通
  // H5 通过callHandler调用Native, Native通过_handleMessageFromNative调用H5

  function JSBridge() {
    // 构造iframe，通过src进行消息传递
    this.jsBridge_iframe = document.createElement('iframe')
    this.jsBridge_iframe.style.display = 'none'
    this.jsBridge_iframe.src = ''
    document.documentElement.appendChild(this.jsBridge_iframe)

    // URL scheme 协议头
    this.JSBridge_protocol = 'JSBridge://'

    // H5注册的本地方法，Native只能调用已注册的方法，否则会报错
    this.messageHandlers = {}
    // 回调函数对象，Native通知H5做回调操作时根据其携带的responseId从这里匹配回调函数然后执行
    this.responseCallbacks = {}

    /**
     * @description 使用此方法调用Native开放的方法
     * @param {Object} params 参数对象，传递handlerName, data, callback
     */
    this.callHandler = function (params) {
      const handlerName = params.handlerName
      const data = params.data || null
      const callback = params.callback || null
      if (!handlerName) {
        console.log('[JSBridge]：callHandler未传入调用方法名')
        return
      }
      this._doSend({
        handlerName: handlerName,
        data: data
      }, callback)
    }

    /**
    * @description 通过该函数注册本地方法供Native调用,如某一具体模块中调用该方法将模块的刷新函数注册到JSBridge,Native就可以通过JSBridge调用该方法
    * @param {String} handlerName
    * @param {Function} handler 需要包含两个参数，data, callback
    */
    this.registerHandler = function (handlerName, handler) {
      this.messageHandlers[handlerName] = handler
    }

    /**
     * @description Native可以使用该方法来调用H5注册的方法，或者通知H5做回调操作
     * @param {String} messageJSON 方法详情 {handlerName,data,callbackId,type}或者{responseData,responseId,type}
     */
    this._handleMessageFromNative = function (messageJSON) {
      setTimeout(_doDispatchMessageFromNative)
      const jsBridgeInstance = this
      function _doDispatchMessageFromNative() {
        let message
        try {
          message = JSON.parse(messageJSON)
        } catch (e) {
          console.error('[JSBridge]: _handleMessageFromNative参数错误')
          return
        }
        if (message.type == 'doCallback') { // 告诉H5执行回调
          if (!message.responseId) {
            console.log('[JSBridge]：未传递responseId')
            return
          }
          const responseCallback = jsBridgeInstance.responseCallbacks[message.responseId]
          if (!responseCallback) {
            console.log('[JSBridge]: responseCallbacks中无对应的回调函数')
            return
          }
          responseCallback(message.responseData)
          delete jsBridgeInstance.responseCallbacks[message.responseId]
        } else if (message.type == 'doAction') { // 直接调用H5注册方法
          let responseCallback
          if (message.callbackId) { // Native希望调用成功后通知它执行回调
            responseCallback = function (responseData) {
              jsBridgeInstance._doSend({
                responseId: message.callbackId,
                responseData: responseData
              })
            }
          }
          const handler = jsBridgeInstance.messageHandlers[message.handlerName]
          if (!handler) {
            console.log(`[JSBridge]: ${message.handlerName}尚未在JSBridge中注册`)
          } else {
            handler(message.data, responseCallback)
          }
        }
      }
    }

    /**
      * @description H5向Native发送消息的具体过程
      * @param {*} message 调用的方法详情,包括方法名,参数
      * @param {*} responseCallback 调用完方法后的回调
      */
    this._doSend = function (message, responseCallback) {
      if (responseCallback) { // 保存回调函数用于后续Native通知执行
        const callbackId = this.generateId()
        this.responseCallbacks[callbackId] = responseCallback
        message['callbackId'] = callbackId
      }
      this.jsBridge_iframe.src = this.generateUri(message) // 发送消息
    }

    /**
     * @description 生成回调ID
     */
    this.generateId = function () {
      return new Date().getTime()
    }

    /**
     * @description 生成URL scheme
     */
    this.generateUri = function (message) {
      let uri = this.JSBridge_protocol
      if (message) {
        // 回调id作为端口存在
        let callbackId, method, callType
        if (message.callbackId) { // 第一种:h5主动调用原生
          callbackId = message.callbackId
          method = message.handlerName
          callType = 'doAction'
          uri += callType + '/' + method + '/' + callbackId + '?' + this.generateParam(message.data)
        } else if (message.responseId) { // 第二种:原生调用h5后,h5回调
          callbackId = message.responseId
          callType = 'doCallback'
          uri += callType + '/' + callbackId + '?' + this.generateParam(message.responseData)
        }
        console.log(`[JSBridge]：消息URL scheme为${uri}`)
      }
      return uri
    }

    /**
     * @description 生成字符串参数
     * @param {*} obj
     */
    this.generateParam = function (obj) {
      if (obj && typeof obj === 'object') {
        return JSON.stringify(obj)
      } else {
        return obj || ''
      }
    }
  }
  return JSBridge
}
]



// WEBPACK FOOTER //
// ./src/js/infrastructure/JSBridge.js